import { CollectionsDueAgronomist } from './hooks/useDueAgronomistQuery';
import i18n from 'utils/i18n';

const { t } = i18n.i18n;

export type AgronomistDueData = {
  agronomistName: string;
  totalDueBalance: number;
  agronomistDueStatus: {
    dueStatus: string;
    remainingBalance: number;
  }[];
};

export const formatAgronomistDueList = (data?: CollectionsDueAgronomist[]) => {
  const agronomistList: AgronomistDueData[] = [];

  data?.forEach((item) => {
    const index = agronomistList.findIndex(
      (x) => x.agronomistName === item.agronomistName,
    );
    if (index === -1) {
      agronomistList.push({
        agronomistName: item.agronomistName,
        totalDueBalance: item.remainingBalance,
        agronomistDueStatus: [
          {
            dueStatus: item.dueStatus,
            remainingBalance: item.remainingBalance,
          },
        ],
      });
    } else {
      agronomistList[index].agronomistDueStatus.push({
        dueStatus: item.dueStatus,
        remainingBalance: item.remainingBalance,
      });
      agronomistList[index].totalDueBalance += item.remainingBalance;
    }

    agronomistList[index]?.agronomistDueStatus.sort(sorterOverdueData);
  });

  return agronomistList;
};

// Sort the due status by "upcoming" first and then "overdue"
export const sorterOverdueData = <T extends { dueStatus: string }>(
  a: T,
  b: T,
): number => {
  if (a.dueStatus === 'upcoming' && b.dueStatus === 'overdue') {
    return -1;
  } else if (a.dueStatus === 'overdue' && b.dueStatus === 'upcoming') {
    return 1;
  } else {
    return 0;
  }
};

export const overdueStatusProperties = {
  upcoming: { title: t('status.Upcoming'), color: 'green' },
  due_3_week: {
    title: t('collectionOverview.status.dueIn3Weeks'),
    color: 'blue',
  },
  due_1_week: {
    title: t('collectionOverview.status.dueIn1Weeks'),
    color: 'gold',
  },
  overdue: { title: t('status.Overdue'), color: 'red' },
};

export type OverdueStatusPropertiesKey = keyof typeof overdueStatusProperties;
